import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useTheme } from '@mui/material/styles';

export default function TablePaginationActionsWithDisable(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange, hasNextPage, showFirstLast } = props;

    const isRtl = theme.direction === 'rtl';
    const isFirstPage = page === 0;

    const lastPage = count >= 0 ? Math.max(0, Math.ceil(count / rowsPerPage) - 1) : 0;

    const isNextDisabled =
        count >= 0
            ? page >= lastPage
            : hasNextPage === false;

    const handleFirstPage = (e) => onPageChange(e, 0);
    const handlePrevPage = (e) => onPageChange(e, page - 1);
    const handleNextPage = (e) => onPageChange(e, page + 1);
    const handleLastPage = (e) => {
        if (count >= 0) onPageChange(e, lastPage);
    };

    return (
        <div style={{ flexShrink: 0, marginLeft: 16 }}>
            {showFirstLast && (
                <IconButton
                    onClick={handleFirstPage}
                    disabled={isFirstPage || count === -1}
                    aria-label="first page"
                >
                    {isRtl ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
            )}

            <IconButton
                onClick={handlePrevPage}
                disabled={isFirstPage}
                aria-label="previous page"
            >
                {isRtl ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>

            <IconButton
                onClick={handleNextPage}
                disabled={isNextDisabled}
                aria-label="next page"
            >
                {isRtl ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>

            {showFirstLast && (
                <IconButton
                    onClick={handleLastPage}
                    disabled={count === -1 || page >= lastPage}
                    aria-label="last page"
                >
                    {isRtl ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            )}
        </div>
    );
}
